import React, { useEffect, useState } from "react";
import { Application, Program } from "../../../core/types/types";
import { useSelector } from "react-redux";
import apiInstance from "../../../utility/apiInstance";

interface PopupProps {
    show: boolean;
    onClose: () => void;
    application: Application | null;
}

const ApplicationDetailsPopup: React.FC<PopupProps> = ({ show, onClose, application }) => {

    const dateOptions: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "short",
        year: "numeric",
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ background: show ? "rgba(0,0,0,0.5)" : "transparent" }}
        >
            <div className="modal-dialog-centered w-50 m-auto" role="document">
                <div className="modal-content">
                    {/* Header */}
                    <div className="modal-header">
                        <h5 className="modal-title text-secondary">Program Application</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        ></button>
                    </div>

                    {/* Body */}
                    <div className="modal-body">
                        <h5 className="fw-bold mb-5 text-center">{application?.program?.programName || ''}</h5>

                        <div className="course-page-content pt-0">
                            <div className="card mb-4 shadow-sm border-0 rounded-3">
                                <div className="card-body">

                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted">Status:</div>
                                        <div className="col-sm-8">
                                            <div className={
                                                application?.status === "pending"
                                                    ? "text-warning fw-bold"
                                                    : application?.status === "in_review"
                                                        ? "text-info fw-bold"
                                                        : application?.status === "approved"
                                                            ? "text-success fw-bold"
                                                            : application?.status === "declined"
                                                                ? "text-danger fw-bold"
                                                                : ""
                                            } >
                                                {application?.status || 'pending'}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted">Applicant:</div>
                                        <div className="col-sm-8">
                                            {application?.student?.firstName || ''} {application?.student?.lastName || ''}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted">Program:</div>
                                        <div className="col-sm-8">
                                            {application?.program?.programName || ''}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted">Institution:</div>
                                        <div className="col-sm-8">
                                            {application?.institution?.schoolName || ''}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted">Application Date:</div>
                                        <div className="col-sm-8">
                                            {application?.createdAt
                                                ? new Date(application?.createdAt).toLocaleDateString(
                                                    "en-IN",
                                                    dateOptions
                                                )
                                                : "-"}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted"> Program Start Date:</div>
                                        <div className="col-sm-8">
                                            {application?.program?.start
                                                ? new Date(application?.program.start).toLocaleDateString(
                                                    "en-IN",
                                                    dateOptions
                                                )
                                                : "-"}
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-sm-4 fw-semibold text-muted"> Program End Date:</div>
                                        <div className="col-sm-8">
                                            {application?.program?.end
                                                ? new Date(application?.program.end).toLocaleDateString(
                                                    "en-IN",
                                                    dateOptions
                                                )
                                                : "-"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="course-page-content pt-0">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h5 className="mb-3 text-primary">Program Details</h5>
                                    {application?.program?.about || ""}
                                </div>
                            </div>
                        </div>
                        {application?.program?.requirement && (
                            <div className="course-page-content pt-0">
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <h5 className="mb-3 text-primary">Program Requirements</h5>
                                        {application?.program?.requirement || ""}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplicationDetailsPopup;
